/**
 * Skip to Content Link - Phase 5.6 Accessibility
 *
 * Provides a skip link for keyboard users to bypass navigation
 * and jump directly to main content.
 *
 * WCAG 2.1 Success Criterion 2.4.1 (Bypass Blocks)
 */

import { useEffect, useState } from 'react';
import useThemeStore from '../../store/themeStore';
import './SkipToContent.css';

export default function SkipToContent() {
  const { resolvedTheme } = useThemeStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleFocus = () => setVisible(true);
    const handleBlur = () => setVisible(false);

    const skipLink = document.getElementById('skip-to-content');
    if (skipLink) {
      skipLink.addEventListener('focus', handleFocus);
      skipLink.addEventListener('blur', handleBlur);

      return () => {
        skipLink.removeEventListener('focus', handleFocus);
        skipLink.removeEventListener('blur', handleBlur);
      };
    }
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a
      id="skip-to-content"
      href="#main-content"
      className={`skip-to-content ${resolvedTheme === 'dark' ? 'dark' : 'light'} ${visible ? 'visible' : ''}`}
      onClick={handleClick}
    >
      Skip to main content
    </a>
  );
}
